import Login from '../Views/Login'
import SearchQuote from '../Views/SearchQuote'
import CrearCotizacion from '../Views/CrearCotizacion'
import MisTareas from '../Views/MisTareas'
import GenerarCotizacion from '../Views/GenerarCotizacion'
import EditarCotizacion from '../Views/EditarCotizacion'
import OrdenDeVenta from '../Views/OrdenDeVenta'
import CartManager from '../Views/CartManager'
import Departments from '../Views/Departments'
import NotFound from '../Views/NotFound'
import SearchInvoicesVadIvend from '../Views/SearchInvoicesVadIvend/index'
import Home from '../Views/Home'
import SearchCustomer from '../Views/SearchCustomer'
import MisListas from '../Views/MisListas'
import VentaPorProducto from '../Views/VentaPorProducto'
import OrdenDeDespacho from 'Views/OrdenDeDespacho'
import SearchSaleOrder from 'Views/SearchSaleOrder'
import SearchDispatch from 'Views/SearchDispatch'
import Deals from 'Views/Ofertas/index'
import Printer from 'Views/Printer'
import PrinterPreview from 'Views/PrinterPreview'
import { ROUTES } from 'Utils/constants'
import MaterialCalculatorSummary from 'Components/MaterialsCalculatorSummary/MaterialCalculatorSummary'
import SearchSaleOrderWeb from 'Views/SearchSaleOrderWeb'
import ApproveSaleOrders from 'Views/ApproveSaleOrders/ApproveSaleOrders'
import OrderTracking from 'Views/OrderTracking/OrderTracking'
import DashboardTracking from 'Views/DashboardTracking/DashboardTracking'
import InstallationService from 'Views/InstallationService/InstallationService'
import InvoiceDetail from 'Views/InvoiceDetail'
import SearchReturnsVadIvend from 'Views/SearchReturnsVadIvend'
import RepaymentDetail from 'Views/RepaymentDetail'
import MaterialsCalculator from 'Views/MaterialsCalculator/MaterialsCalculator'
import CustomerDisplay from 'Views/CustomerDisplay'
import YappyPayment from 'Views/YappyPayment'
import YappyConfig from 'Views/Settings/YappyConfig'
import QuickListSettings from 'Views/Settings/QuickList'
import QuickListInformation from 'Views/Settings/QuickList/QuickListInformation'

const routes = [
  {
    path: ROUTES.yappyPayment,
    element: YappyPayment,
    isPrivate: false,
    exact: true,
  },
  {
    path: ROUTES.login,
    element: Login,
    isPrivate: false,
    exact: true,
  },
  {
    path: ROUTES.home,
    element: Home,
    exact: true,
    isPrivate: true,
  },
  {
    path: ROUTES.printer,
    element: Printer,
    exact: true,
    isPrivate: true,
  },
  {
    path: ROUTES.printerPreview,
    element: PrinterPreview,
    exact: true,
    isPrivate: true,
  },
  {
    path: ROUTES.myTasks,
    element: MisTareas,
    exact: true,
    isPrivate: true,
  },
  {
    path: ROUTES.searchQuote,
    element: SearchQuote,
    exact: true,
    isPrivate: true,
  },
  {
    path: ROUTES.searchSaleOrderWeb,
    element: SearchSaleOrderWeb,
    exact: true,
    isPrivate: true,
  },
  {
    path: ROUTES.searchSaleOrder,
    element: SearchSaleOrder,
    exact: true,
    isPrivate: true,
  },
  {
    path: ROUTES.searchDispatch,
    element: SearchDispatch,
    exact: true,
    isPrivate: true,
  },
  {
    path: ROUTES.createQuote,
    element: CrearCotizacion,
    exact: true,
    isPrivate: true,
  },
  {
    path: ROUTES.generateQuote,
    element: GenerarCotizacion,
    exact: true,
    isPrivate: true,
  },
  {
    path: ROUTES.materialsPreOrder,
    element: MaterialCalculatorSummary,
    exact: true,
    isPrivate: true,
  },
  {
    path: ROUTES.generateQuoteTypeDocument,
    element: GenerarCotizacion,
    exact: true,
    isPrivate: true,
  },
  {
    path: ROUTES.offers,
    element: Deals,
    exact: true,
    isPrivate: true,
  },
  {
    path: ROUTES.installationServiceRequest,
    element: InstallationService,
    exact: true,
    isPrivate: true,
  },

  {
    path: `${ROUTES.saleOrderApprove}:saleOrderDocHeaderId/:saleOrderDocumentNumber`,
    element: ApproveSaleOrders,
    exact: true,
    isPrivate: true,
  },
  {
    path: `${ROUTES.editQuoteHeaderId}:header/:id`,
    element: EditarCotizacion,
    exact: true,
    isPrivate: true,
  },
  {
    path: `${ROUTES.editQuoteHeaderId}:header/:id/edit_cart`,
    element: CartManager,
    exact: true,
    isPrivate: true,
  },
  {
    path: ROUTES.cloneQuote,
    element: CartManager,
    exact: true,
    isPrivate: true,
  },
  {
    path: ROUTES.createQuoteFromList,
    element: CrearCotizacion,
    exact: true,
    isPrivate: true,
  },
  {
    path: ROUTES.departments,
    element: Departments,
    exact: true,
    isPrivate: true,
  },
  {
    path: ROUTES.customers,
    element: SearchCustomer,
    exact: true,
    isPrivate: true,
  },
  {
    path: ROUTES.list,
    element: MisListas,
    exact: true,
    isPrivate: true,
  },
  {
    path: ROUTES.quoteProduct,
    element: VentaPorProducto,
    exact: true,
    isPrivate: true,
  },
  {
    path: ROUTES.salePreorder,
    element: OrdenDeVenta,
    exact: true,
    isPrivate: true,
  },
  {
    path: `${ROUTES.salePreorderValidate}:isPreorderValidatedOnRoute/:id`,
    element: OrdenDeVenta,
    exact: true,
    isPrivate: true,
  },
  {
    path: `${ROUTES.orderDispatch}:id`,
    element: OrdenDeDespacho,
    exact: true,
    isPrivate: true,
  },
  {
    path: ROUTES.searchInvoicesVadIvend,
    element: SearchInvoicesVadIvend,
    isPrivate: true,
    exact: true,
  },
  {
    path: ROUTES.searchReturnsVadIvend,
    element: SearchReturnsVadIvend,
    isPrivate: true,
    exact: true,
  },
  {
    path: `${ROUTES.invoiceDetail}:id`,
    element: InvoiceDetail,
    exact: true,
    isPrivate: true,
  },
  {
    path: ROUTES.orderTracking,
    element: OrderTracking,
    isPrivate: true,
  },
  {
    path: ROUTES.dashboardTracking,
    element: DashboardTracking,
    isPrivate: true,
  },
  {
    path: `${ROUTES.repaymentDetail}:id`,
    element: RepaymentDetail,
    exact: true,
    isPrivate: true,
  },
  {
    path: ROUTES.customerDisplay,
    element: CustomerDisplay,
    isPrivate: true,
  },
  {
    path: ROUTES.materialsCalculator,
    element: MaterialsCalculator,
    isPrivate: true,
  },
  {
    path: ROUTES.yappyConfig,
    element: YappyConfig,
    exact: true,
    isPrivate: true,
  },
  {
    path: ROUTES.quickListSettingsCreate,
    element: QuickListInformation,
    exact: true,
    isPrivate: true,
  },
  {
    path: ROUTES.quickListSettingsEdit,
    element: QuickListInformation,
    exact: true,
    isPrivate: true,
  },
  {
    path: ROUTES.quickListSettings,
    element: QuickListSettings,
    exact: true,
    isPrivate: true,
  },
  {
    path: ROUTES.notFound,
    element: NotFound,
    isPrivate: false,
  },
]

export default routes
